import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import _ from 'lodash';
import {
	createAsset,
	editAsset,
	saveAssets,
} from '../../../../redux/actions';

import { routes } from '../../../../redux/api/routes';
let { s3BucketAPIBaseURL } = routes;

class CreateEditAsset extends Component {
	constructor(props) {
        super(props);
        this.state = {
			confirmationMessage: '',
			errorMessage: '',
			assetForm: {
				params: {
					assetId: '',
					assetType: '',
					customerType: '',
					assetName: '',
					startDate: '',
					endDate: '',
					description: '',
					imageName: '',
					imageLink: '',
					priority: '',
					redirectURL: '',
				},
				errors: {
					assetNameError: '',
					startDateError: '',
					endDateError: '',
					descriptionError: '',
					imageNameError: '',
					priorityError: '',
				}
			},
			minDate: moment(),
			startDate: null,
			endDate: null,
			whichOperation: '',

			fileUploadStatusMessage: '',
			fileUploadStatus: false,
			fileUploadErrorMessage: ''
        }
    }

	handleFileUpload(e) {
        e.preventDefault();
        var self = this,
            files = e.target.files;
        if (files.length > 0) {
			if(files[0].size/1000 > 500) {
				self.setState({
					fileUploadErrorMessage: 'Please select file size upto 500KB',
					fileUploadStatusMessage: '',
					assetForm: {
						...self.state.assetForm,
						errors: {
							...self.state.assetForm.errors,
							imageNameError: '',
						}
					}
				})
			} else {
	            self.setState({
	                fileUploadStatusMessage: 'Please wait until file is uploading.....',
	                fileUploadStatus: true,
	                fileUploadErrorMessage: ''
	            });
	            var file = files[0],
	                reader = new FileReader();
	            reader.addEventListener('loadend', function (e) {
					let { customerType, assetType } = self.state.assetForm.params;
					if(assetType === 'MarketingSlot') {
						assetType = 'Marketing Slots';
					} else {
						assetType = 'Rotating Banners';
					}
					const { userDetails } = self.props.state.user;
	                fetch(s3BucketAPIBaseURL, {
	                    method: "POST",
						headers: {
	                        'Content-Type': 'application/json',
							"Authorization": `${userDetails.jwt}${userDetails.sso}`,
	                    },
	                    body: JSON.stringify({
	                        name:  `CustomerNet/images/${customerType}/${assetType}/${file.name}`,
	                        type: file.type
	                    })
	                }).then(function (response) {
	                    return response.json();
	                }).then(function (json) {
						self.setState({
							assetForm: {
								...self.state.assetForm,
								params: {
									...self.state.assetForm.params,
									imageName: file.name,
									imageLink: json.uploadURL,
								},
								errors: {
									...self.state.assetForm.errors,
									imageNameError: '',
								}
							}
	                    });
	                    return fetch(json.uploadURL, {
	                        method: "PUT",
	                        body: new Blob([reader.result], {
	                            type: file.type
	                        })
	                    })
	                }).then(function () {
	                    self.setState({
	                        fileUploadStatusMessage: 'File is uploaded successfully.',
	                        fileUploadStatus: false,
	                        fileUploadErrorMessage: ''
	                    });
	                });
	            });
	            reader.readAsArrayBuffer(file);
			}
        } else {
            self.setState({
                fileUploadStatusMessage: '',
                fileUploadStatus: false,
                fileUploadErrorMessage: ''
            });
        }
    }

	updateParams(formName, event) {
		//Reseting Errors on change
		const self = this;
		const name = event.target.name;
		self.setState({
			[formName]: {
				...self.state[formName],
				params: {
					...self.state[formName].params,
					[name]: event.target.value
				}
			}
		}, () => {
			if(self.state[formName].errors[name + 'Error']) {
				self.setState({
					[formName]: {
						...self.state[formName],
						errors: {
							...self.state[formName].errors,
							[name+'Error']: ''
						},
					},
				});
			}
		});
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	componentWillMount() {
		const self = this,
			{ assetsFilter, editAsset } = self.props.state.homepage;
		const whichOperation = self.props.params.whichOperation;
		//If there is no existing data available in store, then make service call and get data and then do needful
		if((whichOperation === 'create' && !assetsFilter) || (whichOperation === 'edit' && !editAsset)) {
			browserHistory.push('/siteManagement/manageAssets');
		} else if(whichOperation === 'create') {
			let assetId = 0;
			self.props.state.homepage.assets.responseObject.forEach(itm => {
				if(parseInt(itm.assetId, 10) > assetId) {
					assetId = parseInt(itm.assetId, 10);
				}
			});
			assetId += 1;
			self.setState({
				whichOperation,
				assetForm: {
					...self.state.assetForm,
					params: {
						...self.state.assetForm.params,
						createdDate: moment().format('MM/DD/YYYY'),
						updatedDate: moment().format('MM/DD/YYYY'),
						assetId,
						assetType: assetsFilter.assetType,
						customerType: assetsFilter.accountType,
					}
				}
			});
		} else {	// In case of edit asset
			self.setState({
				whichOperation,
				assetForm: {
					...self.state.assetForm,
					params: JSON.parse(JSON.stringify(editAsset)),
				},
				startDate: moment(editAsset.startDate),
				endDate: moment(editAsset.endDate),
			});
		}
	}

	handleSubmit(event) {
		const self = this;
		const { params, errors } = self.state.assetForm;
		let formError = false;
		//Reset all errors
		for(var key in errors) {
            if(!params[key.replace("Error","")]) {
                errors[key] = 'error';
                formError = true;
            } else {
				errors[key] = '';
			}
        }
		self.setState({
			params,
			errors,
			serviceCallCompleted: false
		}, () => {
			if(!formError) {
				const payload = JSON.parse(JSON.stringify(self.state.assetForm.params));
				delete payload.imageLink;
				// make service call accordingly
				if(self.state.whichOperation === 'create') {
					self.props.createAsset(payload, '', response => {
						if(response.status && response.responseObject) {
							const { assets } = JSON.parse(JSON.stringify(self.props.state.homepage));
							assets.responseObject.push(response.responseObject);
							self.props.saveAssets(assets);
							self.setState({
								serviceCallCompleted: true
							});
						} else {
							browserHistory.push('/error');
						}
					});
				} else {
					self.props.editAsset(payload, '', response => {
						if(response.status && response.responseObject) {
							const { assets } = JSON.parse(JSON.stringify(self.props.state.homepage));
							assets.responseObject.forEach(itm => {
								if(itm.assetId === response.responseObject.assetId) {
									itm = response.responseObject;
								}
							});
							self.props.saveAssets(assets);
							self.setState({
								serviceCallCompleted: true
							});
						} else {
							browserHistory.push('/error');
						}
					});
				}
			}
		});
	}

	handleChangeStartDate(date) {
	  	const self = this;
	  	self.setState({
		  	startDate: date,
			assetForm: {
				...self.state.assetForm,
				params: {
					...self.state.assetForm.params,
			  		startDate: date && date.format('MM/DD/YYYY')
				},
				errors: {
					...self.state.assetForm.errors,
					startDateError: ""
				}
		  	}
	  	});
	}

	handleChangeEndDate(date) {
		const self = this;
	  	self.setState({
		  	endDate: date,
			assetForm: {
				...self.state.assetForm,
				params: {
					...self.state.assetForm.params,
			  		endDate: date && date.format('MM/DD/YYYY')
				},
				errors: {
					...self.state.assetForm.errors,
					endDateError: ""
				}
		  	}
	  	});
	}

	removeKey(url) {
		let path = url.indexOf("?AWSAccessKeyId=") !== -1 ? url.substring(0, url.indexOf("?AWSAccessKeyId=")) : url;
		return path;
	}

    render() {
		const self = this;
		const { assetForm: { params, errors } } = self.state;
        return (
            <div>
				<div className="push">
					<h1 className="pageTitle">Home Page Assets</h1>
				</div>
				{this.state.errorMessage?<p className="red bold push">{this.state.errorMessage}</p>:null}
				{this.state.confirmationMessage?<p className="bold push">{this.state.confirmationMessage}</p>:null}
				{this.state.serviceCallCompleted && <div>
					{this.state.whichOperation === 'create' && <p className="bold red">Asset has been created successfully.</p>}
					{this.state.whichOperation === 'edit' && <p className="bold red">Asset has been updated successfully.</p>}
				</div>}
				<div className="largePush">
					<p className="bold red" id="errorMessage">{this.state.errorMessage}</p>
					<table style={{width: '100%'}} className="formTableTypeA createOrderTableA">
						<tbody>
							<tr>
								<td className="first-column">Asset Name</td>
								<td className="middle-column">
									<input disabled={this.state.serviceCallCompleted} className={errors.assetNameError} defaultValue={params.assetName} type="text" name="assetName" onChange={this.updateParams.bind(this, 'assetForm')} />
								</td>
								<td className={errors.imageNameError} rowSpan={ 7 }>
									<input disabled={this.state.serviceCallCompleted} accept="image/jpeg,image/pjpeg,image/gif,image/png,image/bmp,image/x-windows-bmp" onChange={this.handleFileUpload.bind(this)} type="file" /> &nbsp;
									<br />
									{errors.imageNameError && <p className="bold red">Please select a image</p>}
									{this.state.fileUploadStatus === false && params.imageLink &&
										<div className="bold image-thumb">
											<a href={this.removeKey(params.imageLink)} target="_blank">
												<img src={this.removeKey(params.imageLink)} alt={params.imageName} /><br />
												{params.imageName}
											</a>
										</div>
									}
									{this.state.fileUploadErrorMessage?<p className="red"><b>{this.state.fileUploadErrorMessage}</b></p>:null}
									{this.state.fileUploadStatusMessage?<p className="bold">{this.state.fileUploadStatusMessage}</p>:null}
								</td>
							</tr>
							<tr>
								<td className="first-column">Description</td>
								<td className="middle-column">
									<input disabled={this.state.serviceCallCompleted} className={errors.descriptionError} defaultValue={params.description} type="text" name="description" onChange={this.updateParams.bind(this, 'assetForm')} />
								</td>
							</tr>
							<tr>
								<td className="first-column">Priority</td>
								<td className="middle-column">
									<input disabled={this.state.serviceCallCompleted} className={errors.priorityError} onKeyPress={this.props.acceptNumbersOnly} defaultValue={params.priority} type="text" name="priority" onChange={this.updateParams.bind(this, 'assetForm')} />
								</td>
							</tr>
							<tr>
								<td className="first-column">Redirect URL</td>
								<td className="middle-column">
									<input disabled={this.state.serviceCallCompleted} defaultValue={params.redirectURL} type="text" name="redirectURL" onChange={this.updateParams.bind(this, 'assetForm')} />
								</td>
							</tr>
							<tr>
								<td className="first-column">Start Date</td>
								<td className="middle-column">
									<div className={errors.startDateError}>
										<DatePicker disabled={this.state.serviceCallCompleted} id="startDate" minDate={self.state.minDate} placeholderText="Click to select a date" selected={self.state.startDate} onChange={this.handleChangeStartDate.bind(this)} />&nbsp;<var>(mm/dd/yyyy)</var>
									</div>
								</td>
							</tr>
							<tr>
								<td className="first-column">End Date</td>
								<td className="middle-column">
									<div className={errors.endDateError}>
										<DatePicker disabled={this.state.serviceCallCompleted} id="endDate" minDate={self.state.minDate} placeholderText="Click to select a date" selected={self.state.endDate} onChange={this.handleChangeEndDate.bind(this)} />&nbsp;<var>(mm/dd/yyyy)</var>
									</div>
								</td>
							</tr>
							{!this.state.serviceCallCompleted && <tr>
								<td />
								<td className="middle-column">
		                            <input type="button" onClick={this.handleSubmit.bind(this)} className="blueButton uppercase" defaultValue="Submit" />
								</td>
							</tr>}
						</tbody>
					</table>
					{this.state.serviceCallCompleted && <div>
						<p><Link to={"/siteManagement/manageAssets"}>Return to Previous Screen</Link></p>
						<div className="clear" />
					</div>}
					<p>
						<Link to="/siteManagement">Back to Site Management</Link>
					</p>
				</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	createAsset: (payload, hybridQueryParams, callback) => dispatch(createAsset(payload, hybridQueryParams, callback)),
	editAsset: (payload, hybridQueryParams, callback) => dispatch(editAsset(payload, hybridQueryParams, callback)),
	saveAssets: (data) => dispatch(saveAssets(data)),
});

CreateEditAsset = connect(mapStateToProps, mapDispatchToProps)(CreateEditAsset);
export default CreateEditAsset;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/ManageAssets/createEditAsset.js